(function LivePlannerVideoTwilio($, Adzuki)
{
	"use strict";

	// old stuff from Twilio, we may not use this anymore
	var LPVideo                = {};
	// var twilio                 = Twilio.Video;
	var twilio                 = null;
	var current_room           = null;
	var current_room_name      = null;
	var current_type           = null;
	var current_video_bg       = null;
	var $main_video_box        = $('.lp-video-box');
	var $large_video_container = $('.lp-large-video');
	var $small_video_container = $('.lp-small-video');
	var screen_video_track     = null;
	var large_video_track      = null;
	var large_audio_track      = null;
	var small_video_track      = null;
	var small_audio_track      = null;

	// eslint-disable-next-line no-unused-vars
	function _blurBackground($elem)
	{
		var $text_elem = null;
		var video_bg   = null;

		if (current_room === null) {
			_throwError('Not connected to a room', 'blur_background');
		}

		if ($elem.hasClass('disabled')) {
			return;
		}

		if ($elem.find('span').first().length > 0) {
			$text_elem = $elem.find('span').first();
		}

		current_room.localParticipant.videoTracks.forEach(function _eachVideoTrack(video_track) {
			if (video_track.track.name === (current_type + '_video')) {
				$elem.addClass('disabled');

				if ($text_elem !== null) {
					$text_elem.html('Working...');
				}

				video_bg = new Twilio.VideoProcessors.GaussianBlurBackgroundProcessor({
					assetsPath      : Adzuki.base_uri + '/adzuki/js/vendor/twilio',
					maskBlurRadius  : 5,
					blurFilterRadius: 15,
				});

				current_video_bg = video_bg;

				video_bg.loadModel().then(function _modelLoaded() {
					if ($text_elem !== null) {
						$text_elem.html('Remove Blur Background');
					}

					$elem.data('blurred', 1);
					$elem.attr('data-original-title', 'Remove Blur Background');
					$elem.removeClass('disabled');

					video_track.track.addProcessor(current_video_bg);
				});
			}
		});
	}

	// eslint-disable-next-line no-unused-vars
	function _browserSupportsTwilio()
	{
		return twilio.isSupported;
	}

	// eslint-disable-next-line no-unused-vars
	function _browserSupportsTwilioVideoBackgrounds()
	{
		return Twilio.VideoProcessors.isSupported;
	}

	// eslint-disable-next-line no-unused-vars
	function _closePictureInPicture()
	{
		var $video_container = null;

		if (!document.pictureInPictureElement) {
			return;
		}

		if (current_type === 'client') {
			$video_container = $main_video_box;

			// re-organize the agent's contact info
			$('.lp-agent-contact-info')
				.removeClass('col-sm-12 pad20-vert-bottom')
				.addClass('col-sm-6');
		} else {
			$video_container = $main_video_box.find('.lp-video-container').first();
		}

		document.exitPictureInPicture();
		$video_container.removeClass('hidden');
	}

	// eslint-disable-next-line no-unused-vars
	function _logError(msg, action)
	{
		var post_data = {
			generated_by : current_type,
			action       : action,
			room_name    : current_room_name,
			error        : true,
			error_message: msg,
		};

		Adzuki.Ajax.post('/LivePlanner/logVideoAction', post_data);
	}

	// eslint-disable-next-line no-unused-vars
	function _muteAudio($elem)
	{
		var $text_elem = null;

		if (current_room === null) {
			_throwError('Not connected to a room', 'mute_audio');
		}

		current_room.localParticipant.audioTracks.forEach(function _eachAudioTrack(audio_track) {
			audio_track.track.disable();
		});

		$elem.data('muted', 1);
		$elem.attr('data-original-title', 'Unmute');
		$elem.find('i').first()
		.removeClass('adzicon-microphone fa-microphone')
		.addClass('adzicon-microphone-slash fa-microphone-slash');

		if ($elem.find('span').first().length > 0) {
			$text_elem = $elem.find('span').first();

			$text_elem.html('Unmute');
		}
	}

	// eslint-disable-next-line no-unused-vars
	function _restoreClientPageHeader()
	{
		// hide and show a few things
		$('.lp-video-box').addClass('hidden');
		$('.lp-web-video-btns').addClass('hidden');
		$('.lp-web-join-video').addClass('hidden');
		$('.lp-agent-contact-info').removeClass('centered');
		$('.lp-agent-contact-photo').removeClass('hidden');
	}

	// eslint-disable-next-line no-unused-vars
	function _shareScreen($elem)
	{
		var $text_elem         = null;
		var display_media_opts = {
			video: {
				cursor: 'always',
			},
			audio: false,
		};

		if ($elem) {
			$text_elem = $elem.find('span').first();
		}

		if (current_room === null) {
			_throwError('Not connected to a room', 'share_screen');
		}

		if (screen_video_track !== null) {
			// user is currently sharing their screen
			// unpublish the video track and we are done
			current_room.localParticipant.unpublishTrack(screen_video_track);
			screen_video_track.detach();
			screen_video_track.stop();
			screen_video_track = null;

			if ($text_elem) {
				$text_elem.html('Share your screen');
			}

			return;
		}

		navigator.mediaDevices.getDisplayMedia(display_media_opts)
		.then(function _getMediaTrack(media_stream) {
			screen_video_track = new twilio.LocalVideoTrack(
				media_stream.getVideoTracks()[0],
				{ name: 'screen_share' }
			);

			if ($text_elem) {
				$text_elem.html('Stop sharing your screen');
			}

			current_room.localParticipant.publishTrack(screen_video_track, { priority: 'high' })
			.then(function _trackPublished(publication) {
				// when the user tells the browser that they want to stop sharing their screen
				screen_video_track.mediaStreamTrack.onended = function _stopScreenShare() {
					LPVideo.shareScreen($elem);
				};
			}).catch(function _onError(error) {
				_throwError(error.message, 'share_screen');
			});
		}).catch(function _onError(error) {
			_throwError(error.message, 'share_screen');
		});
	}

	// eslint-disable-next-line no-unused-vars
	function _showAgentStartVideoBtn()
	{
		$('.lp-start-video').parent().removeClass('hidden');
		$('.lp-start-video').find('span').first().html('Start Video');
		$('.lp-sidebar').affix('checkPosition');
	}

	// eslint-disable-next-line no-unused-vars
	function _startTwilioVideo(token, room_name, type)
	{
		var opts = {
			name : room_name,
			audio: false,
			video: false,
		};

		current_room_name = room_name;
		current_type = type;

		// make sure the user's browser is supported
		if (!twilio.isSupported) {
			_throwError('Your browser is not currently supported, the most recent version of Google Chrome is recommended', 'connect');
		}

		$main_video_box.removeClass('hidden');
		$('.lp-sidebar').affix('checkPosition');

		twilio.connect(token, opts).then(function _connected(room) {
			var promises   = [];
			var video_opts = {
				name     : type + '_video',
				width    : 1280,
				height   : 720,
				frameRate: 24,
			};

			$large_video_container.html('');
			$small_video_container.html('').removeClass('bordered');
			$('.lp-sidebar').affix('checkPosition');

			current_room = room;

			promises.push(twilio.createLocalVideoTrack(video_opts));
			promises.push(twilio.createLocalAudioTrack({ name: type + '_audio' }));

			// load the appropriate background effect (if any) for the agent
			if (current_type === 'agent') {
				if (Twilio.VideoProcessors.isSupported) {
					promises.push(_loadVideoBackground());
				} else {
					Adzuki.StatusMessage('Warning', 'Your browser does not support virtual backgrounds, the most recent version of Google Chrome is recommended', 'Virtual Backgrounds');
				}
			}

			Promise.all(promises)
			.then(function _onAll(created_tracks) {
				large_video_track = created_tracks[0];
				large_audio_track = created_tracks[1];

				room.localParticipant.publishTrack(large_video_track, {
					priority: 'high',
				});

				room.localParticipant.publishTrack(large_audio_track, {
					priority: 'high',
				});

				$large_video_container.append(large_video_track.attach());
				$large_video_container.append(large_audio_track.attach());

				// add picture-in-picture icon if the browser supports it
				if (document.pictureInPictureEnabled) {
					$large_video_container.append(_getPictureInPictureIcon());
					$large_video_container.off()
					.on('click', '.lp-pip-status', _openPictureInPicture);
				}

				if (current_video_bg !== null) {
					large_video_track.addProcessor(current_video_bg);
				}

				$('.lp-sidebar').affix('checkPosition');

				// disconnect in case the agent/client refreshes/leaves the page with video on
				$(window).on('beforeunload', function beforeUnload() {
					if (current_room !== null) {
						current_room.disconnect();
					}
				});

				// there's already someone in the room
				// use this person's video track as the main one
				if (room.participants.size > 0) {
					room.participants.forEach(function _onEachParticipant(participant) {
						_joinParticipant(participant);
					});
				}

				// a remote participant has joined the room
				// use this person's video track as the main one
				room.on('participantConnected', function _connected(participant) {
					_joinParticipant(participant);
				});

				// a remote participant has left the room
				room.on('participantDisconnected', function _disconnected(participant) {
					// move the local participant's video track to the
					// main area and hide the small video area
					_removeLargeVideoTrack();

					large_video_track = small_video_track;
					large_audio_track = small_audio_track;
					small_video_track = null;
					small_audio_track = null;

					$large_video_container.append(large_video_track.attach());
					$large_video_container.append(large_audio_track.attach());

					// add picture-in-picture icon if the browser supports it
					if (document.pictureInPictureEnabled) {
						$large_video_container.append(_getPictureInPictureIcon());
						$large_video_container.off()
						.on('click', '.lp-pip-status', _openPictureInPicture);
					}

					$small_video_container.html('');
					$small_video_container.removeClass('bordered');
				});

				// the local participant has disconnected from the room
				room.on('disconnected', function _disconnected(room, error) {
					room.localParticipant.tracks.forEach(function _onEachTrack(public_track) {
						public_track.unpublish();
						public_track.track.stop();
					});

					LPVideo.stop();

					if (current_type === 'agent') {
						LPVideo.showAgentStartVideoBtn();
					} else if (current_type === 'client') {
						LPVideo.restoreClientPageHeader();
					}

					if (error) {
						_throwError('Unexpectedly disconnected: ' + error, 'disconnect');
					}
				});
			}).catch(function _onError(error) {
				// one of the callbacks in Promise.all() failed
				_throwError(error.message, 'connect');
			});
		}).catch(function _onError(error) {
			// connect() failed
			_throwError(error.message, 'connect');
		});
	}

	// eslint-disable-next-line no-unused-vars
	function _stopTwilioVideo()
	{
		if (current_room === null) {
			_throwError('No video call available to disconnect', 'stop');
		}

		current_room.disconnect();

		if (large_video_track) {
			large_video_track.detach();
			large_video_track = null;
		}

		if (large_audio_track) {
			large_audio_track.detach();
			large_audio_track = null;
		}

		if (small_video_track) {
			small_video_track.detach();
			small_video_track = null;
		}

		if (small_audio_track) {
			small_audio_track.detach();
			small_audio_track = null;
		}

		if (screen_video_track) {
			screen_video_track.detach();
			screen_video_track = null;
		}

		LPVideo.closePictureInPicture();

		$large_video_container.html('');
		$small_video_container.html('').removeClass('bordered');
		$main_video_box.addClass('hidden');
	}

	function _throwError(msg, action)
	{
		_logError(msg, action);

		throw new Error(msg);
	}

	// eslint-disable-next-line no-unused-vars
	function _unmuteAudio($elem)
	{
		var $text_elem = null;

		if (current_room === null) {
			_throwError('Not connected to a room', 'unmute');
		}

		current_room.localParticipant.audioTracks.forEach(function _eachAudioTrack(audio_track) {
			audio_track.track.enable();
		});

		$elem.data('muted', 0);
		$elem.attr('data-original-title', 'Mute');
		$elem.find('i').first()
		.removeClass('adzicon-microphone-slash fa-microphone-slash')
		.addClass('adzicon-microphone fa-microphone');

		if ($elem.find('span').first().length > 0) {
			$text_elem = $elem.find('span').first();

			$text_elem.html('Mute');
		}
	}

	// eslint-disable-next-line no-unused-vars
	function _removeBlurBackground($elem)
	{
		var $text_elem = null;

		if (current_room === null) {
			_throwError('Not connected to a room', 'blur_background');
		}

		if (current_video_bg === null) {
			_throwError('No background effect to remove', 'blur_background');
		}

		current_room.localParticipant.videoTracks.forEach(function _eachVideoTrack(video_track) {
			if (video_track.track.name === (current_type + '_video')) {
				video_track.track.removeProcessor(current_video_bg);
				current_video_bg = null;
			}
		});

		$elem.data('blurred', 0);
		$elem.attr('data-original-title', 'Blur Background');

		if ($elem.find('span').first().length > 0) {
			$text_elem = $elem.find('span').first();

			$text_elem.html('Blur Background');
		}
	}

	function _getAudioIcon(is_enabled)
	{
		var icon_markup = '<div class="lp-top-icon lp-mute-status">';
		var icon        = '<i class="adzicon-microphone-slash fas fa-fw fa-microphone-slash"></i>';

		if (is_enabled === true) {
			icon = '<i class="adzicon-microphone fas fa-fw fa-microphone"></i>';
		}

		icon_markup += icon;
		icon_markup += '</div>';

		return icon_markup;
	}

	function _getPictureInPictureIcon()
	{
		var icon_markup = '<div class="lp-top-icon lp-pip-status" ';
		icon_markup += 'data-toggle="tooltip" data-placement="top" data-original-title="Popout Video">';
		icon_markup += '<i class="adzicon-window-restore fas fa-fw fa-window-restore"></i>';
		icon_markup += '</div>';

		return icon_markup;
	}

	function _getWindowActionsHtml()
	{
		var markup = '<div class="lp-window-actions">';
		markup += '<a href="#" class="lp-minimize-video" data-toggle="tooltip" ';
		markup += 'data-placement="top" title="Minimize Video">';
		markup += '<i class="adzicon-window_minimize fas fa-fw fa-window-minimize"></i>';
		markup += '</a>';
		markup += '</div>';

		return markup;
	}

	function _joinParticipant(participant)
	{
		// remote participant has joined the call
		// take the local video track (which is the large one)
		// and set it as the small video track
		// the remote feed will become the large video track now
		small_video_track = large_video_track;
		small_audio_track = large_audio_track;

		LPVideo.closePictureInPicture();
		_removeLargeVideoTrack();

		$small_video_container.html('');
		$small_video_container.append(small_video_track.attach());
		$small_video_container.append(small_audio_track.attach());
		$small_video_container.append(_getWindowActionsHtml());
		$small_video_container.addClass('bordered');

		$small_video_container.off().on('click', '.lp-minimize-video', _minimizeAndMaximizeVideo);

		// if the participant is joining a room with someone already in it
		// the other user's video/audio tracks should be already subscribed
		participant.tracks.forEach(function _onEachTrack(remote_track) {
			if (remote_track.isSubscribed && remote_track.kind === 'video') {
				large_video_track = remote_track.track;
				$large_video_container.append(large_video_track.attach());

				// add picture-in-picture icon if the browser supports it
				if (document.pictureInPictureEnabled) {
					$large_video_container.append(_getPictureInPictureIcon());
					$large_video_container.off()
					.on('click', '.lp-pip-status', _openPictureInPicture);
				}
			}

			if (remote_track.isSubscribed && remote_track.kind === 'audio') {
				large_audio_track = remote_track.track;
				$large_video_container.append(_getAudioIcon(remote_track.track.isEnabled));
				$large_video_container.append(large_audio_track.attach());

				// the track has been muted
				remote_track.track.on('disabled', function _onDisabled(track) {
					_updateAudioIcon(false);
				});

				// the track has been unmuted
				remote_track.track.on('enabled', function _onEnabled(track) {
					_updateAudioIcon(true);
				});
			}
		});

		// this is fired when a new audio/video/screen-share track is subscribed to the room
		// this could happen when there's no one in the room but yourself
		// and somebody else joins in, their video track becomes the main one
		// in the case that this is a screen share, then we use the sharing
		// video track as the main one
		participant.on('trackSubscribed', function _subscribed(track, publication) {
			var large_video_media_elems = null;
			var small_video_media_elems = null;

			if (!publication.isSubscribed) {
				return;
			}

			LPVideo.closePictureInPicture();

			if (track.kind === 'video') {
				if (track.name === 'screen_share') {
					if (small_video_track !== null) {
						small_video_media_elems = small_video_track.detach();

						small_video_media_elems.forEach(function _onEach(media_el) {
							media_el.remove();
						});
					}

					if (large_video_track !== null) {
						// remove remote video feed from the large video view
						large_video_media_elems = large_video_track.detach();

						large_video_media_elems.forEach(function _onEach(media_el) {
							media_el.remove();
						});

						// take that remote video feed and add it to the small video view
						small_video_track = large_video_track;
						$small_video_container.prepend(small_video_track.attach());

						// take the screen share video feed and add it to the large video view
						large_video_track = track;
						$large_video_container.append(large_video_track.attach());
						$large_video_container.find('.lp-pip-status').remove();
					}
				} else {
					large_video_track = track;
					$large_video_container.append(large_video_track.attach());
					$large_video_container.find('.lp-pip-status').remove();
				}

				// add picture-in-picture icon if the browser supports it
				if (document.pictureInPictureEnabled) {
					$large_video_container.append(_getPictureInPictureIcon());
					$large_video_container.off()
					.on('click', '.lp-pip-status', _openPictureInPicture);
				}
			}

			if (track.kind === 'audio') {
				large_audio_track = track;
				$large_video_container.append(large_audio_track.attach());
				$large_video_container.append(_getAudioIcon(track.isEnabled));

				// the track has been muted
				track.on('disabled', function _onDisabled(track) {
					_updateAudioIcon(false);
				});

				// the track has been unmuted
				track.on('enabled', function _onEnabled(track) {
					_updateAudioIcon(true);
				});
			}
		});

		// whenever a remote track is unpublished/unsubscribed from the room
		participant.on('trackUnsubscribed', function _unsubscribed(track, publication) {
			var large_video_media_elems = null;
			var small_video_media_elems = null;

			LPVideo.closePictureInPicture();

			// the remote participant stopped sharing their screen
			if (track.kind === 'video' && track.name === 'screen_share') {
				large_video_media_elems = large_video_track.detach();
				small_video_media_elems = small_video_track.detach();

				large_video_media_elems.forEach(function _onEach(media_el) {
					media_el.remove();
				});

				small_video_media_elems.forEach(function _onEach(media_el) {
					media_el.remove();
				});

				small_video_track = null;
				large_video_track = null;

				// find the remote video track and set it as the main one
				current_room.participants.forEach(function _onEach(participant) {
					participant.tracks.forEach(function _eachTrack(remote_track) {
						if (
							remote_track.isSubscribed
							&& remote_track.kind === 'video'
							&& remote_track.track.name === 'client_video'
						) {
							large_video_track = remote_track.track;
							$large_video_container.append(large_video_track.attach());
							$large_video_container.find('.lp-pip-status').remove();

							// add picture-in-picture icon if the browser supports it
							if (document.pictureInPictureEnabled) {
								$large_video_container.append(_getPictureInPictureIcon());
								$large_video_container.off()
								.on('click', '.lp-pip-status', _openPictureInPicture);
							}
						}
					});
				});

				// find the local video track and set it as the small video
				current_room.localParticipant.tracks.forEach(function _onEach(local_track) {
					if (
						local_track.kind === 'video'
						&& local_track.isTrackEnabled
						&& local_track.track.name === 'agent_video'
					) {
						small_video_track = local_track.track;
						$small_video_container.addClass('bordered')
						.prepend(small_video_track.attach());
					}
				});
			}
		});
	}

	function _loadBgImage(url)
	{
		var promise = new Promise(function _callback(resolve, reject) {
			var img = new Image();
			img.src = url;

			if (img.complete) {
				resolve(img);
			} else {
				img.onload = function _loaded() {
					resolve(img);
				};

				img.onerror = function _error() {
					reject('There was an error loading the image');
				};
			}
		});

		return promise;
	}

	async function _loadVideoBackground()
	{
		var response = null;
		var bg_image = null;
		var video_bg = null;

		try {
			response = await Adzuki.Ajax.get('/LivePlanner/getAgentBackgroundImage');
		} catch (error) {
			return Promise.resolve(null);
		}

		// no background image specified
		if (response.image === 'none') {
			return Promise.resolve(null);
		}

		// agent is using a blurred background
		if (response.image === 'blur') {
			video_bg = new Twilio.VideoProcessors.GaussianBlurBackgroundProcessor({
				assetsPath      : Adzuki.base_uri + '/adzuki/js/vendor/twilio',
				maskBlurRadius  : 5,
				blurFilterRadius: 15,
			});

			current_video_bg = video_bg;

			return video_bg.loadModel();
		}

		// agent is using a background image
		try {
			bg_image = await _loadBgImage(response.image);
		} catch (error) {
			return Promise.resolve(null);
		}

		// image is loaded ok, create the background processor for it
		video_bg = new Twilio.VideoProcessors.VirtualBackgroundProcessor({
			assetsPath     : Adzuki.base_uri + '/adzuki/js/vendor/twilio',
			backgroundImage: bg_image,
			maskBlurRadius : 5,
			fitType        : Twilio.VideoProcessors.ImageFit.Cover,
		});

		current_video_bg = video_bg;

		return video_bg.loadModel();
	}

	function _minimizeAndMaximizeVideo(e)
	{
		var $button = $(this);
		var $icon   = $button.find('i').first();

		e.preventDefault();

		// video already minimized, restore it back up
		if ($small_video_container.hasClass('minimized')) {
			$small_video_container.removeClass('minimized');
			$small_video_container.addClass('bordered');
			$button.attr('title', 'Minimize Video');
			$button.attr('data-original-title', 'Minimize Video');
			$icon.removeClass('adzicon-window_maximize fa-window-maximize');
			$icon.addClass('adzicon-window_minimize fa-window-minimize');

			return;
		}

		$small_video_container.addClass('minimized');
		$small_video_container.removeClass('bordered');
		$button.attr('title', 'Maximize Video');
		$button.attr('data-original-title', 'Maximize Video');
		$icon.removeClass('adzicon-window_minimize fa-window-minimize');
		$icon.addClass('adzicon-window_maximize fa-window-maximize');
	}

	function _openPictureInPicture(e)
	{
		var video_elem       = $large_video_container.find('video').first().get(0);
		var $video_container = null;

		// if there's already a video in picture-in-picture mode, disable it
		LPVideo.closePictureInPicture();

		if (current_type === 'client') {
			$video_container = $main_video_box;

			// center the agent's contact information since the video feed is hidden
			$('.lp-agent-contact-info')
				.removeClass('col-sm-6')
				.addClass('col-sm-12 pad20-vert-bottom');
		} else {
			$video_container = $main_video_box.find('.lp-video-container').first();
		}

		$(this).addClass('hidden');

		$video_container.addClass('hidden');

		$(video_elem).off().on('leavepictureinpicture', function _onLeavePip(e) {
			var pip_icon = $large_video_container.find('.lp-pip-status').first();

			pip_icon.removeClass('hidden');
			$video_container.removeClass('hidden');

			if (current_type === 'client') {
				// re-organize the agent's contact info
				$('.lp-agent-contact-info')
					.removeClass('col-sm-12 pad20-vert-bottom')
					.addClass('col-sm-6');
			}
		});

		video_elem.requestPictureInPicture();
	}

	function _removeLargeVideoTrack()
	{
		var video_media_elems = null;
		var audio_media_elems = null;

		if (large_video_track !== null) {
			video_media_elems = large_video_track.detach();

			video_media_elems.forEach(function _onEach(media_el) {
				media_el.remove();
			});
		}

		if (large_audio_track !== null) {
			audio_media_elems = large_audio_track.detach();

			audio_media_elems.forEach(function _onEach(media_el) {
				media_el.remove();
			});
		}

		large_video_track = null;
		large_audio_track = null;

		$large_video_container.html('');
	}

	function _updateAudioIcon(is_enabled)
	{
		var $audio_icon = $large_video_container.find('.lp-mute-status i').first();

		if (is_enabled === true) {
			$audio_icon
			.removeClass('adzicon-microphone-slash fa-microphone-slash')
			.addClass('adzicon-microphone fa-microphone');

			return;
		}

		$audio_icon
		.removeClass('adzicon-microphone fa-microphone')
		.addClass('adzicon-microphone-slash fa-microphone-slash');
	}

	Adzuki.LPVideoTwilio = LPVideo;

}(jQuery, window.Adzuki || {}));
